import { render, staticRenderFns } from "./badges.vue?vue&type=template&id=bb96b6a8&scoped=true&lang=pug&"
import script from "./badges.vue?vue&type=script&lang=coffee&"
export * from "./badges.vue?vue&type=script&lang=coffee&"
import style0 from "./badges.vue?vue&type=style&index=0&id=bb96b6a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb96b6a8",
  null
  
)

export default component.exports